module.exports = __webpack_public_path__ + "img/drug_card_layout__separate__sv.3cce04df.png";